import { h, Component } from "preact";
import { connectWithTranslations } from "../../../common/helpers/translationsHelpers";
import SpeechScore from "../rows/SpeechScore";
import SpeechAverageScore from "../rows/SpeechAverageScore";
class SpeechTrackerModal extends Component {
    constructor(props) {
        super(props);
    }

    render({ translate }) {
        const speechScoreExample = {
            scoreLevel: -1,
            score: 6.7,
            averageScore: 3.3,
            averageScoreLevel: 1,
            isVotingMember: false,
        };

        return (
            <div class="fxs_c_modal-backdrop">
                <div class="fxs_c_modal_content_speech_tracker">
                    <p class="fxs_c_speech_tracker_modal-title">
                        New Speech Tracker
                    </p>
                    <svg
                        class="fxs_c_speech_tracker_modal-close"
                        width="35"
                        height="35"
                        viewBox="0 0 35 35"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        onClick={this.props.toggleSpeechTrackerModal}
                    >
                        <path
                            d="M19.6924 17.5L22.8639 14.3728C23.2531 13.9891 23.2531 13.3669 22.8639 12.9828L22.1591 12.2878C21.7699 11.9041 21.1389 11.9041 20.7494 12.2878L17.5779 15.415L14.4064 12.2878C14.0172 11.9041 13.3862 11.9041 12.9967 12.2878L12.2919 12.9828C11.9027 13.3666 11.9027 13.9887 12.2919 14.3728L15.4634 17.5L12.2919 20.6272C11.9027 21.0109 11.9027 21.6331 12.2919 22.0172L12.9967 22.7122C13.3859 23.0959 14.0172 23.0959 14.4064 22.7122L17.5779 19.585L20.7494 22.7122C21.1386 23.0959 21.7699 23.0959 22.1591 22.7122L22.8639 22.0172C23.2531 21.6334 23.2531 21.0113 22.8639 20.6272L19.6924 17.5Z"
                            fill="#1B1C23"
                        />
                    </svg>
                    <img src="https://editorial.blob.core.windows.net/images/EcoCal/speechTrackerModalImage.png" />

                    <div class="fxs_c_speech_tracker_modal_wrapper">
                        <p class="fxs_c_speech_tracker_modal_description">
                            {translate("SpeechTrackerModalDescription")}
                        </p>
                        <div class="fxs_c_speech_tracker_modal_block">
                            <div className="fxs_c_speech_score_detail_wrapper">
                                <p class="fxs_c_speech_tracker_average_score">
                                    <span>{`${translate("VotingMember")}: `}</span>
                                    <span className="fxs_c_speech_score">
                                        {speechScoreExample?.isVotingMember
                                            ? translate("Yes")
                                            : translate("No")}
                                    </span>
                                </p>
                                <p class="fxs_c_speech_tracker_score">
                                    <span>
                                        {translate("SpeechTrackerScoreLabel")}
                                    </span>
                                    {speechScoreExample.score ? (
                                        <SpeechScore
                                            speechScore={speechScoreExample}
                                        />
                                    ) : (
                                        <span className="fxs_c_speech_score">
                                            -
                                        </span>
                                    )}
                                </p>
                                <p class="fxs_c_speech_tracker_average_score">
                                    <SpeechAverageScore
                                        speechScore={speechScoreExample}
                                        includeName={true}
                                    />
                                </p>
                            </div>
                            <p class="fxs_c_speech_tracker_modal_description">
                                {translate("SpeechTrackerModalDisclaimer")}
                            </p>
                        </div>
                    </div>
                    <div class="fxs_c_speech_tracker_modal_buttons">
                        <a
                            href="#bottom"
                            class="fxs_c_read_more_btn"
                            onClick={this.props.toggleSpeechTrackerModal}
                        >
                            {translate("ReadMore")}
                        </a>
                        <a
                            href="/account/login?uriToRedirect=%2Feconomic-calendar%3FuserAction%3Dlogin"
                            class="fxs_c_unlock_btn"
                            data-ga4event-clk-name="features-calendar_click"
                            data-ga4event-element="log-in"
                        >
                            {translate("LogIn")}
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}
export default connectWithTranslations("")(SpeechTrackerModal);
